import React from 'react';

const LoadingPlaceholder = () => (
  <div
    className="loadImage"
    style={{
      width: '50px',
      height: '50px',
      border: '2px solid',
      animation: 'spinner 1s linear infinite',
      marginRight: '9px',
      borderRadius: '50%',
      borderTopColor: '#c7e0f4',
      borderLeftColor: '#0078d4',
      borderRightColor: '#c7e0f4',
      borderBottomColor: '#c7e0f4',
      margin: '60px auto',
    }}
  />
);

export default LoadingPlaceholder;
